import { Variant } from './Product/Variant';
import Dinero from 'dinero.js';
var CartItem = /** @class */ (function () {
    function CartItem() {
    }
    CartItem.createFromApi = function (dto) {
        return Object.assign(new CartItem(), dto, {
            variant: Variant.createFromApi(dto.variant),
            price: Dinero({ amount: Math.round(dto.price * 100), currency: 'USD' }),
            fullPrice: Dinero({ amount: Math.round(dto.fullPrice * 100), currency: 'USD' })
        });
    };
    return CartItem;
}());
export { CartItem };
var CountedCartItem = /** @class */ (function () {
    function CountedCartItem() {
    }
    return CountedCartItem;
}());
export { CountedCartItem };
export var VariantType;
(function (VariantType) {
    VariantType["Digital"] = "Digital";
    VariantType["Print"] = "Print";
})(VariantType || (VariantType = {}));
